"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.button = void 0;

var _Button = require("../Button/Button.style");

const button = ({
  cssProps,
  theme
}) => {
  const {
    size
  } = cssProps;
  const {
    buttonIcons: buttonIconsTheme
  } = theme;
  const isSmall = size === 'small';
  return { ...(0, _Button.css)({
      theme,
      cssProps: { ...cssProps,
        size: 'large'
      }
    }),
    height: isSmall ? buttonIconsTheme.sizeSmall : buttonIconsTheme.size,
    padding: 0,
    width: isSmall ? buttonIconsTheme.sizeSmall : buttonIconsTheme.size
  };
};

exports.button = button;
//# sourceMappingURL=ButtonIcon.style.js.map